import { defineComponent as o, openBlock as u, createBlock as a, unref as p, mergeProps as s } from "vue";
import l from "./ghl-ui.es347.js";
const i = o({
  name: "UIMenu",
  inheritAttrs: !1
}), m = o({
  ...i,
  props: {
    options: {
      type: Array
    },
    value: {
      type: [String, Number]
    }
  },
  emits: ["update:value"],
  setup(e) {
    return (t, n) => (u(), a(p(l), s({
      options: e.options,
      "onUpdate:value": n[0] || (n[0] = (r) => t.$emit("update:value", r)),
      value: e.value
    }, t.$attrs), null, 16, ["options", "value"]));
  }
}), d = m;
export {
  d as default
};
